import React, { Fragment, useEffect, useState } from "react";
import PageHeader from "../../common/components/PageHeader";
import { Box, CircularProgress, Divider, Grid, Typography } from "@mui/material";
import CommonCard from "../../common/components/CommonCard";
import theme from "../../theme";
import CommonButton from "../../common/components/CommonButton";
import { Add, Close } from "@mui/icons-material";
import CommonSelect from "../../common/components/CommonSelect";
import { AreaObj, ExamAttempt, ExamPlans, ExamStatus, ExamType, ExamTypeArr, ExamTypes, removeEmptyFields, ExamSubjectArea, ServiceOffer, TopUpServices, TimeBlocks, Semesters } from "../../common/const";
import CommonFormField from "../../common/components/CommonFormField";
import ExamListing from "./ExamListing";
import CommonDialog from "../../common/components/CommonDialog";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { setLoading } from "../../features/authSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { createExam, getExamList, getUpComingExamList, updateExam } from "../../api/examApi";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import CurrentPlan from "../../common/components/CurrentPlan";
import ProgrssBar from "./ProgressBar";
import { getScoreStats } from "../../api/scoreApi";
import { getDashBoardDetails, getStudentTestGoal } from "../../api/satactApi";

const Exams = () => {
  const dispatch = useDispatch();
  const { user, loading } = useSelector((state) => state.auth);
  const [addOpen, setAddOpen] = useState(false);
  const [edit, setEdit] = useState(null);
  const [errors, setErrors] = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [exams, setExams] = useState([]);
  const [upComingExams, setUpcomingExams] = useState([]);
  const [examType, setExamType] = useState(ExamTypes.ACT_SAT);
  const [progressData, setProgressData] = useState(null);
  const [latestScore, setLatestScore] = useState(null);
  const [formData, setFormData] = useState({
    examType: ExamSubjectArea[0].value,
    type: ExamType.ACT,
    examDate: '',
    status: ExamStatus[0]?.value,
    gpa: '',
    grade: '',
    semester: Semesters?.["Semester 1"],
    firstAttempt: ExamAttempt[0].value,
    subjects: []
  });
  const [subjectName, setSubjectName] = useState(null);
  const [examDate, setExamDate] = useState('');
  const [filters, setFilters] = useState({
    exam_type: ExamTypes.ACT_SAT,
    start_date: '',
    end_date: '',
    semester: ''
  });
  const [addSession, setAddSession] = useState(false);
  const [successOpen, setSuccess] = useState(false);
  const [selectedService, setSelectedServices] = useState(TopUpServices[0].label);
  const [timing, selectTiming] = useState(TimeBlocks[0].value);

  useEffect(() => {
    if (edit !== null) {
      setFormData({
        examType: edit.exam_type,
        type: edit.test_type,
        examDate: edit.exam_date ? moment(edit.exam_date).format('YYYY-MM-DD') : '',
        status: edit.status,
        gpa: edit.gpa,
        grade: edit.grade,
        semester: edit?.semester,
        firstAttempt: edit.attempt,
        subjects: edit.subjects
      });
    }
  }, [edit]);

  const validateField = (name, value) => {
    switch (name) {
      case 'examType':
        if (!value) return 'Exam Type is required';
        return '';
      case 'examDate':
        if (!value && formData.examType === AreaObj.SAT_SCT) return 'Exam Date is required';
        return '';
      default:
        return '';
    }
  };

  const validateForm = () => {
    const newErrors = {};
    Object.keys(formData).forEach(key => {
      const error = validateField(key, formData[key]);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'examType') {
      if (value === AreaObj.SAT_SCT) {
        setFormData((prev) => ({
          ...prev,
          type: ExamType.ACT
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          type: ExamTypeArr[0].value
        }));
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      const error = validateField(name, value);
      if (!error) {
        setErrors(prev => ({ ...prev, [name]: undefined }));
      } else {
        setErrors(prev => ({ ...prev, [name]: error }));
      }
    }
  };

  const handleSubmit = async () => {
    try {
      if (!validateForm()) return;
      if (formData.examType !== AreaObj.SAT_SCT && formData.subjects.length === 0) {
        showNotification('Please add subject', 'error');
        return;
      }
      dispatch(setLoading({
        loading: true
      }));
      let response;
      const data = {
        "exam_type": formData.examType, //ACT_SAT ACADEMICS AP_EXAMS SKILL
        "test_type": formData.type, // SAT  ACT  QUIZ  MID_TERMS  FINALS
        "exam_date": formData.examDate ? new Date(formData.examDate).toISOString() : '',
        "gpa": formData.gpa,
        "grade": formData.grade,
        semester: formData?.semester,
        "status": formData.status,
        "attempt": formData.firstAttempt, //  FIRST_TIME  SECOND_TIME  THIRD_TIME
        "student_id": user?.student_id
      }
      if (formData?.subjects?.length > 0) {
        data.subjects = formData.subjects
      }
      if (edit) {
        response = await updateExam(edit.exam_id, removeEmptyFields(data));
      } else {
        response = await createExam(removeEmptyFields(data));
      }
      if (response.success) {
        setFormData({
          examType: ExamSubjectArea[0].value,
          type: ExamType.ACT,
          examDate: '',
          status: ExamStatus[0]?.value,
          gpa: '',
          grade: '',
          semester: Semesters?.["Semester 1"],
          firstAttempt: ExamAttempt[0].value,
          subjects: []
        });
        dispatch(setLoading({
          loading: true
        }));
        showNotification(response.message, 'success');
        getExams();
        getUpComingExam();
      }
      setAddOpen(false);
    } catch (err) {
      const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
      showNotification(errorMessage, 'error');
      dispatch(setLoading({
        loading: false
      }));
    }
  };

  const getExams = async () => {
    try {
      dispatch(setLoading({ loading: true }));
      const response = await getExamList(user?.student_id, pageNo, 12, JSON.stringify(filters));

      if (response.data.data.length > 0) {
        // Merge arrays and remove duplicates based on unique identifier (e.g., id)
        const mergedExams = [...exams, ...response.data.data];
        const uniqueExams = Array.from(
          new Map(mergedExams.map(exam => [exam.exam_id, exam])).values()
        );
        setExams(uniqueExams);
      } else if (pageNo === 1) {
        // Only reset to empty array on first page if no data
        setExams([]);
      }

      dispatch(setLoading({ loading: false }));
    } catch (err) {
      const errorMessage = err.response?.data?.errors?.[0]?.message ||
        err.response?.data?.message ||
        err?.response?.data?.error;
      showNotification(errorMessage, 'error');
      dispatch(setLoading({ loading: false }));
    }
  }

  const getUpComingExam = async () => {
    try {
      dispatch(setLoading({ loading: true }));
      const response = await getUpComingExamList(user?.student_id);
      setUpcomingExams(response.data);
      dispatch(setLoading({ loading: false }));
    } catch (err) {
      const errorMessage = err.response?.data?.errors?.[0]?.message ||
        err.response?.data?.message ||
        err?.response?.data?.error;
      showNotification(errorMessage, 'error');
      dispatch(setLoading({ loading: false }));
    }
  }

  useEffect(() => {
    if (user?.student_id) {
      getExams();
    }
  }, [user, filters]);

  useEffect(() => {
    if (user?.student_id) {
      getUpComingExam();
    }
  }, [user]);

  const getStats = async () => {
    try {
      dispatch(setLoading({
        loading: true
      }));
      const response = await getScoreStats(examType === ExamTypes.SKILLS ? ServiceOffer.skillCoach : examType === ExamTypes.APEXAM ? 'AP_TUTORING' : 'ACADEMIC_TUTORING', user?.student_id, '');
      dispatch(setLoading({
        loading: false
      }));
      setProgressData(response.data);
    } catch (err) {
      const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
      showNotification(errorMessage, 'error');
      dispatch(setLoading({
        loading: false
      }));
    }
  };

  useEffect(() => {
    if (user?.student_id) {
      if ([ExamTypes.APEXAM, ExamTypes.ACADEMIC, ExamTypes.SKILLS]?.includes(examType)) {
        getStats();
      } else {
        getScoreData();
      }
    }
  }, [user, examType]);

  const getScoreData = async () => {
    try {
      dispatch(setLoading({
        loading: true
      }));
      const response = await getDashBoardDetails(ExamType.SAT, user?.student_id);
      let data = response?.data?.latest;
      const goalResponse = await getStudentTestGoal(ExamType.SAT, user?.student_id);
      if (goalResponse.data?.length > 0) {
        data.goalData = goalResponse.data[0];
      }
      setLatestScore(data);
      dispatch(setLoading({
        loading: false
      }));
    } catch (err) {
      const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
      showNotification(errorMessage, 'error');
      dispatch(setLoading({
        loading: false
      }));
    }
  }

  const getMinDate = () => {
        const date = filters.start_date ? new Date(filters.start_date) : new Date();
        date.setDate(date.getDate() + 1); // Add 7 days
        return date.toISOString().split('T')[0];
    };

  return (
    <Fragment>
      {loading && (
        <LoadingSpinner />
      )}
      <CommonDialog
        open={successOpen}
        size="xs"
        title={
          <Fragment>
            <Close
              sx={{
                color: theme.palette.background.dark, fontSize: 20,
                float: 'right',
                cursor: 'pointer'
              }}
              onClick={() => {
                setSuccess(false);
                setAddSession(true);
              }}
            />
          </Fragment>
        }
        content={(
          <center>
            <img
              src='/Images/success.png'
              alt='Check Circle'
              style={{ width: '70px', height: '70px', marginTop: 20 }}
            />
            <Typography sx={{ fontWeight: 600, fontSize: '22px', mt: 0.5 }}>
              Hours Added Successfully
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph mt={0.3}>
              You have added {TimeBlocks.find((a) => a.value === timing)?.time}s to your project Mentoring Balance
            </Typography>
            <CommonCard
              paddingBottom="0px"
              borderRadius={2}
              background="#FAFAFA"
              content={
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography fontWeight={600}>Available Sessions</Typography>
                      <Typography fontWeight={600} color="#10AE2D">+ {TimeBlocks.find((a) => a.value === timing)?.time}s</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <CommonCard
                      paddingBottom="0px"
                      padding="10px 10px 5px 10px"
                      borderRadius={2}
                      marginTop="0px"
                      content={
                        <Box textAlign="left">
                          <Typography fontWeight={600}>02</Typography>
                          <Typography color="background.dark">Previous</Typography>
                        </Box>
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <CommonCard
                      paddingBottom="0px"
                      padding="10px 10px 5px 10px"
                      borderRadius={2}
                      marginTop="0px"
                      content={
                        <Box textAlign="left">
                          <Typography fontWeight={600}>{Number(TimeBlocks.find((a) => a.value === timing)?.time?.split(' ')?.[0]) + 2} Hours</Typography>
                          <Typography color="background.dark">Updated</Typography>
                        </Box>
                      }
                    />
                  </Grid>
                </Grid>
              }
            />
          </center>
        )}
        actionButtons={(
          <CommonButton
            label="Return To Dashboard"
            size="small"
            marginBottom="10px"
            handleClick={() => {
              setSuccess(false);
              setAddSession(false);
              setSelectedServices(TopUpServices[0].label);
              selectTiming(TimeBlocks[0].value);
            }}
          />
        )}
      />
      <CommonDialog
        open={addSession}
        size="md"
        title={
          <Fragment>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography sx={{ fontWeight: 600, fontSize: 18 }}>Top up Your Session</Typography>
              <Close
                sx={{
                  color: theme.palette.background.dark, fontSize: 20,
                  float: 'right',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  setAddSession(false);
                  setSelectedServices(TopUpServices[0].label);
                  selectTiming(TimeBlocks[0].value);
                }}
              />
            </Box>
            <Box width="80%" mb={1}>
              <Typography sx={{ fontSize: 12 }} color={theme.palette.background.dark}>Purchase additional hours for your plan</Typography>
            </Box>
            <Divider />
          </Fragment>
        }
        content={
          <Grid container spacing={1} mt={0.1}>
            <Grid item md={12}>
              <Typography fontWeight={600}>Which service do you need more time for?</Typography>
            </Grid>
            {(examType ? TopUpServices.filter((i) => i.examType === examType || i?.examType?.includes(examType)) : TopUpServices).map((a, index) => (
              <Grid item xs={examType ? 12 : 2.4} key={index} onClick={() => setSelectedServices(a.label)}>
                <CommonCard
                  paddingBottom="0px"
                  borderRadius={2}
                  marginTop="0px"
                  height="100px"
                  border={!examType && `3px solid ${selectedService === a.label ? a.color === 'white' ? theme.palette.primary.main : a.color : '#000001A'}`}
                  background={a.background}
                  content={
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',           // Take full height of parent
                        width: '100%',            // Take full width of parent
                        flexDirection: 'column',
                        textAlign: 'center'
                      }}
                    >
                      <img src={a.image} alt="icon" />
                      <Typography mt={0.5} fontSize={14} color={a.color}>
                        {a.label}
                      </Typography>
                    </Box>
                  }
                />
              </Grid>
            ))}
            <Grid item md={12}>
              <Typography fontWeight={600}>Choose a Time Block</Typography>
            </Grid>
            {TimeBlocks.map((a, index) => (
              <Grid item xs={3} key={index} onClick={() => selectTiming(a.value)}>
                {a.popular ? (
                  <Box
                    sx={{
                      position: 'relative',
                      height: 'fit-content'
                    }}
                  >
                    <CommonCard
                      paddingBottom="0px"
                      borderRadius={2}
                      marginTop="0px"
                      background={timing === a.value ? theme.palette.secondary.main : '#FFEECF'}
                      content={
                        <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center">
                          <Typography fontSize={15} textAlign="center" fontWeight={600} color={timing === a.value ? 'white' : 'black'}>{a.time}</Typography>
                          <Typography fontSize={17} textAlign="center" fontWeight={600} color={timing === a.value ? 'white' : theme.palette.primary.main}>{a.value}</Typography>
                          <Typography fontSize={14} textAlign="center" color={timing === a.value ? 'white' : theme.palette.background.dark}>{a.label}</Typography>
                        </Box>
                      }
                    />
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '-9px',
                        right: '65px',
                        backgroundColor: '#D08700',
                        color: 'white',
                        padding: '2px 10px',
                        borderRadius: '12px',
                        fontSize: '10px',
                        zIndex: 10
                      }}
                    >
                      Most Popular
                    </Box>
                  </Box>
                ) : (
                  <CommonCard
                    paddingBottom="0px"
                    borderRadius={2}
                    marginTop="0px"
                    background={timing === a.value ? theme.palette.secondary.main : '#FFEECF'}
                    content={
                      <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center">
                        <Typography fontSize={15} textAlign="center" fontWeight={600} color={timing === a.value ? 'white' : 'black'}>{a.time}</Typography>
                        <Typography fontSize={17} textAlign="center" fontWeight={600} color={timing === a.value ? 'white' : theme.palette.primary.main}>{a.value}</Typography>
                        <Typography fontSize={14} textAlign="center" color={timing === a.value ? 'white' : theme.palette.background.dark}>{a.label}</Typography>
                      </Box>
                    }
                  />
                )}
              </Grid>
            ))}
          </Grid>
        }
        actionButtons={(
          <Box display="flex" justifyContent="space-between" width="100%" mt={2}>
            <Box>
              <Typography fontWeight={600}>{selectedService}</Typography>
              <Box display="flex" gap={1}>
                <Typography color={theme.palette.background.dark}>{TimeBlocks.find((a) => a.value === timing)?.time} - </Typography>
                <Typography color={theme.palette.secondary.main} fontWeight={600}>{timing}</Typography>
              </Box>
            </Box>
            <CommonButton
              label="Proceed To Payment"
              size="small"
              background={theme.palette.secondary.main}
              color={theme.palette.background.main}
              fontWeight={700}
              marginBottom="10px"
              width="180px"
              handleClick={() => {
                setSuccess(true);
              }}
            />
          </Box>
        )}
      />
      <PageHeader
        title="My Exams & Score Performance"
        content={
          <Typography color="background.dark" sx={{ fontSize: 14, }}>
            Your journey to success
          </Typography>
        }
        buttonContent={
          examType !== ExamTypes.ACT_SAT ? (
            <ProgrssBar progressData={progressData} />
          ) : (
            <Box display="flex" gap={1} width={'50%'}>
              {latestScore?.composite_score && (
                <Box width="100%">
                  <CommonCard
                    paddingBottom="0px"
                    padding="10px"
                    borderRadius={1}
                    content={
                      <Box>
                        <Typography fontWeight={600}>SAT</Typography>
                        <Box display="flex" gap={1}>
                          <Box sx={{ position: 'relative', display: 'inline-flex', ml: 1 }}>
                            <CircularProgress
                              variant="determinate"
                              value={100}
                              size={50}
                              thickness={6}
                              sx={{
                                color: '#e0e0e0', // Light gray for remaining portion
                                position: 'absolute',
                                '& .MuiCircularProgress-circle': {
                                  strokeLinecap: 'round',
                                },
                              }}
                            />
                            <CircularProgress
                              variant="determinate"
                              value={parseFloat(((latestScore?.composite_score * 100) / 1600)).toFixed(2)}
                              size={50}
                              thickness={6}
                              sx={{
                                color: ((latestScore?.composite_score * 100) / 1600) >= 85
                                  ? theme.palette.secondary.default
                                  : ((latestScore?.composite_score * 100) / 1600) >= 50
                                    ? theme.palette.primary.main
                                    : ((latestScore?.composite_score * 100) / 1600) > 0
                                      ? 'red'// Full green
                                      : theme.palette.secondary.default, // Your progress color
                                '& .MuiCircularProgress-circle': {
                                  strokeLinecap: 'round',
                                },
                              }}
                            />
                            <Box
                              sx={{
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                position: 'absolute',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              <Typography
                                fontSize={11}
                                component="div"
                                fontWeight={700}
                                color="text.primary"
                              >
                                {`${latestScore?.composite_score ? parseFloat(((latestScore?.composite_score * 100) / 1600)).toFixed(1) : 0}%`}
                              </Typography>
                            </Box>
                          </Box>
                          <Box>
                            <Typography color={theme.palette.background.dark}><span style={{ color: theme.palette.secondary.main, fontWeight: 600 }}>{latestScore?.composite_score || 0}</span>/1600</Typography>
                            <Typography color={theme.palette.background.dark} fontSize={14} textAlign="center">Avg score</Typography>
                          </Box>
                        </Box>
                        <Box display="flex" gap={2} mt={1} ml={7}>
                          {latestScore?.studentTestSectionScores?.map((a) => (
                            <Box>
                              <Typography color={theme.palette.background.dark}><span style={{ color: theme.palette.secondary.main, fontWeight: 600 }}>{a?.score || 0}</span>/800</Typography>
                              <Typography color={theme.palette.background.dark} fontSize={14} textAlign="center">{a?.section}</Typography>
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    }
                  />
                </Box>
              )}
              {latestScore?.goalData?.target_composite && (
                <Box width="60%">
                  <CommonCard
                    paddingBottom="0px"
                    padding="10px"
                    borderRadius={1}
                    content={
                      <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center" mt={2.5} mb={2.5}>
                        <img src={`/Images/${latestScore?.goalData?.target_composite <= latestScore?.composite_score ? 'checkcircle.png' : 'watchLater.png'}`} height="35px" />
                        <Typography fontWeight={600} color={theme.palette.secondary.main} fontSize={16} mt={0.5}>{latestScore?.goalData?.target_composite}</Typography>
                        <Typography color={theme.palette.background.dark}>Target Score</Typography>
                      </Box>
                    }
                  />
                </Box>
              )}
              {latestScore?.goalData?.target_composite && (
                <Box width="60%">
                  <CommonCard
                    paddingBottom="0px"
                    padding="5px"
                    borderRadius={1}
                    background={latestScore?.goalData?.target_composite <= latestScore?.composite_score ? '#F0FDF4' : '#FEF9C2'}
                    content={
                      <Box sx={{ border: `2px solid ${latestScore?.goalData?.target_composite <= latestScore?.composite_score ? 'green' : theme.palette.primary.main}`, borderRadius: 1, p: 0.8 }}>
                        <Box sx={{
                          border: `3.5px solid ${latestScore?.goalData?.target_composite <= latestScore?.composite_score ? 'green' : theme.palette.primary.main}`,
                          borderRadius: 1,
                          px: 1,
                          py: latestScore?.goalData?.target_composite <= latestScore?.composite_score ? 2.2 : 1.5
                        }}>
                          {latestScore?.goalData?.target_composite <= latestScore?.composite_score ? (
                            <Typography textAlign="center" fontSize={13} color="green">Congratulations, you
                              achieved your required SAT score for your dream/target college.
                            </Typography>
                          ) : (
                            <Typography textAlign="center" fontSize={12} color={theme.palette.primary.main}>
                              It seems you're still behind your SAT required score, do you want to take out SAT/ACT coaching?
                              <br />
                              <span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => setAddSession(true)}>Add More Sessions</span>
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    }
                  />
                </Box>
              )}
            </Box>
          )
        }
      />
      <CommonDialog
        open={addOpen}
        size="xs"
        title={
          <Fragment>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography sx={{ fontWeight: 600, fontSize: 18 }}>{edit !== null ? "Edit Exam" : "Add New Exam"}</Typography>
              <Close
                sx={{
                  color: theme.palette.background.dark, fontSize: 20,
                  float: 'right',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  setAddOpen(false);
                  setFormData({
                    examType: ExamSubjectArea[0].value,
                    type: ExamType.ACT,
                    examDate: '',
                    status: ExamStatus[0]?.value,
                    gpa: '',
                    grade: '',
                    semester: Semesters?.["Semester 1"],
                    firstAttempt: ExamAttempt[0].value,
                    subjects: []
                  });
                  setErrors({});
                }}
              />
            </Box>
            <Box width="80%" mb={0.5}>
              <Typography sx={{ fontSize: 12 }} color={theme.palette.background.dark}>Track your progress towards your goals 🎯</Typography>
            </Box>
            <Divider />
          </Fragment>
        }
        content={
          <Grid container spacing={1.5} mb={2} mt={0.1}>
            <Grid item xs={12}>
              <CommonSelect
                label="Exam Type"
                name="examType"
                value={formData.examType}
                onChange={handleInputChange}
                error={errors.examType}
                placeholder="Select Exam Type"
                options={ExamSubjectArea}
              />
            </Grid>
            {[AreaObj.AP_EXAM, AreaObj.Skills].includes(formData.examType) && (
              <Grid item xs={12} md={12}>
                <CommonSelect
                  label="Select Attempt"
                  name="firstAttempt"
                  value={formData.firstAttempt}
                  onChange={handleInputChange}
                  error={errors.firstAttempt}
                  options={ExamAttempt}
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <CommonCard
                borderRadius={1}
                border={`1px solid ${theme.palette.cardbackground.main}`}
                background={theme.palette.cardbackground.secondary}
                padding="10px"
                paddingBottom="0px"
                marginTop="8px"
                content={
                  <Fragment>
                    {formData.examType === AreaObj.SAT_SCT ? (
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography fontWeight={600}>Select Type</Typography>
                          <Box mt={1} display="flex" gap={1}>
                            <CommonButton
                              label={ExamType.ACT}
                              width="50%"
                              fontWeight={600}
                              border={formData.type !== ExamType.ACT ? `1px solid #0000001A` : 'none'}
                              color={formData.type === ExamType.ACT ? theme.palette.primary.main : 'gray'}
                              background={formData.type === ExamType.ACT ? theme.palette.secondary.main : '#FAFAFA'}
                              handleClick={() => {
                                setFormData((prev) => ({
                                  ...prev,
                                  type: ExamType.ACT,
                                }));
                                setErrors({});
                              }}
                              marginBottom="0px"
                            />
                            <CommonButton
                              label={ExamType.SAT}
                              width="50%"
                              border={formData.type !== ExamType.SAT ? `1px solid #0000001A` : 'none'}
                              fontWeight={600}
                              color={formData.type === ExamType.SAT ? theme.palette.primary.main : 'gray'}
                              background={formData.type === ExamType.SAT ? theme.palette.secondary.main : '#FAFAFA'}
                              handleClick={() => {
                                setFormData((prev) => ({
                                  ...prev,
                                  type: ExamType.SAT,
                                }));
                                setErrors({});
                              }}
                              marginBottom="0px"
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <CommonFormField
                            label="Exam Date"
                            type="date"
                            name="examDate"
                            value={formData.examDate}
                            onChange={handleInputChange}
                            error={errors.examDate}
                            placeholder="MM-DD-YYYY"
                          />
                        </Grid>
                      </Grid>
                    ) : (
                      <Grid container spacing={1} p="13px 5px 13px 5px">
                        <Typography fontWeight={600} ml={1}>Subject</Typography>
                        <Grid item xs={12}>
                          {formData?.subjects?.length > 0 && (
                            <Box>
                              {formData.subjects.map((i, ind) => (
                                <CommonCard
                                  key={ind}
                                  marginTop="10px"
                                  paddingBottom="0px"
                                  padding="8px 13px 8px 13px"
                                  borderRadius={1}
                                  content={
                                    <Box display="flex" justifyContent="space-between">
                                      <Box>
                                        <Typography fontWeight={600} fontSize={15}>{i.name}</Typography>
                                        <Typography fontSize={14} color={theme.palette.background.dark}>Exam Date {i.exam_date ? moment(i.exam_date)?.format('DD MMM, YYYY') : ''}</Typography>
                                      </Box>
                                      <CommonButton
                                        label="Delete"
                                        color="white"
                                        background="red"
                                        height="25px"
                                        width="70px"
                                        marginBottom="0px"
                                        handleClick={() => {
                                          setFormData((prev) => ({
                                            ...prev,
                                            subjects: formData.subjects.filter((u) => u.id !== i.id)
                                          }))
                                        }}
                                      />
                                    </Box>
                                  }
                                />
                              ))}
                            </Box>
                          )}
                        </Grid>
                        <Grid item xs={12}>
                          <CommonFormField
                            label="Subject Name"
                            type="email"
                            name="examDate"
                            value={subjectName}
                            onChange={(e) => setSubjectName(e.target.value)}
                            placeholder="Enter Subject"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <CommonFormField
                            label="Exam Date"
                            type="date"
                            name="examDate"
                            value={examDate}
                            onChange={(e) => setExamDate(e.target.value)}
                            placeholder="MM-DD-YYYY"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <CommonButton
                            label="Add Subject"
                            startIcon={<Add />}
                            background="White"
                            color="black"
                            height="35px"
                            width="140px"
                            marginBottom="0px"
                            handleClick={() => {
                              if (subjectName) {
                                if (examDate !== '') {
                                  setFormData((prev) => ({
                                    ...prev,
                                    subjects: [...formData.subjects, {
                                      id: formData.subjects.length + 1,
                                      name: subjectName,
                                      exam_date: examDate
                                    }]
                                  }));
                                  setExamDate('');
                                  setSubjectName('');
                                } else {
                                  showNotification('Please select exam date', 'error');
                                }
                              } else {
                                showNotification('Please enter subject', 'error');
                              }
                            }}
                          />
                        </Grid>
                      </Grid>
                    )
                    }
                  </Fragment>
                }
              />
            </Grid>
            {formData.examType !== AreaObj.SAT_SCT && (
              <Fragment>
                <Grid item xs={12} md={12}>
                  <CommonSelect
                    label="Semester"
                    name="semester"
                    value={formData.semester}
                    onChange={handleInputChange}
                    placeholder="Select Semester"
                    options={[{
                      label: 'Semester 1', value: 'SEMESTER_1'
                    },
                    {
                      label: 'Semester 2', value: 'SEMESTER_2'
                    }]}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CommonFormField
                    label="Grade"
                    type="email"
                    name="grade"
                    value={formData.grade}
                    onChange={handleInputChange}
                    error={errors.grade}
                    placeholder="Enter Grade"
                  />
                </Grid>
                <Grid item xs={6}>
                  <CommonFormField
                    label="Enter GPA"
                    type="number"
                    name="gpa"
                    value={formData.gpa}
                    onChange={handleInputChange}
                    placeholder="Enter GPA"
                  />
                </Grid>
              </Fragment>
            )}
            {formData.examType !== AreaObj.SAT_SCT && (
              <Grid item xs={12}>
                <CommonSelect
                  label="Exam Type"
                  name="type"
                  value={formData.type}
                  onChange={handleInputChange}
                  error={errors.type}
                  options={ExamTypeArr}
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <CommonSelect
                label="Select Status"
                name="status"
                value={formData.status}
                onChange={handleInputChange}
                error={errors.status}
                options={ExamStatus}
              />
            </Grid>
          </Grid>
        }
        actionButtons={(
          <CommonButton
            label={edit === null ? "Add Exam" : "Save Exam"}
            size="small"
            background={theme.palette.secondary.main}
            color={theme.palette.background.main}
            fontWeight={700}
            marginBottom="10px"
            handleClick={() => {
              handleSubmit();
            }}
          />
        )}
      />
      <Grid container spacing={1} mt={0.5}>
        <Grid item md={12}>
          <CommonCard
            borderRadius={2}
            paddingBottom="0px"
            marginTop="0px"
            content={
              <Box display="flex" gap={1}>
                <CommonSelect
                  name="subjectArea"
                  placeholder="All Tests"
                  value={filters.exam_type}
                  onChange={(e) => {
                    setExamType(e.target.value);
                    setFilters((prev) => ({
                      ...prev,
                      exam_type: e.target.value,
                      semester: ''
                    }));
                    setExams([]);
                  }}
                  options={ExamSubjectArea}
                  width="22%"
                />
                <CommonFormField
                  type="date"
                  name="startDate"
                  value={filters.start_date}
                  onChange={(e) => setFilters((prev) => ({
                    ...prev,
                    start_date: e.target.value
                  }))}
                  placeholder="Start Date"
                  width="22%"
                />
                <CommonFormField
                  type="date"
                  name="endDate"
                  value={filters.end_date}
                  onChange={(e) => setFilters((prev) => ({
                    ...prev,
                    end_date: e.target.value
                  }))}
                  placeholder="End Date"
                  width="22%"
                  minDate={getMinDate()}
                />
                <CommonButton
                  label="Sort My Exam Info"
                  marginBottom="0px"
                  fontWeight={600}
                  color="white"
                  background={theme.palette.secondary.main}
                  width="170px"
                  handleClick={() => {
                    setPageNo(1);
                    setExams([]);
                    getExams();
                  }
                  }
                />
              </Box>
            }
          />
        </Grid>
        <Grid item md={9} mt={1}>
          {examType === ExamTypes.ACT_SAT && (
            <CommonCard
              marginTop="8px"
              paddingBottom="0px"
              borderRadius={2}
              headerContent={
                <Fragment>
                  <Box sx={{ p: 2, pb: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography fontWeight={600}>Upcoming Exams within a week</Typography>
                    <CurrentPlan
                      fromExam
                      label={`Add More ${examType === ExamTypes.ACT_SAT ? 'SAT/ACT' : examType === ExamTypes.ACADEMIC ? 'Academic' : examType === ExamTypes.APEXAM ? 'AP Exam' : 'Skill'} Session`}
                      examType={examType}
                    />
                  </Box>
                </Fragment>
              }
              content={
                upComingExams.length > 0 ? (
                  <Grid container spacing={1}>
                    {upComingExams.map((a, index) => (
                      <Grid item md={6} sm={12}>
                        <CommonCard
                          key={index}
                          paddingBottom="0px"
                          borderRadius={1}
                          padding="13px"
                          marginTop="0px"
                          background={index % 2 === 0 ? '#DCFCE7' : '#FEF9C2'}
                          content={
                            a.subjects?.length > 0 ? (
                              <Box>
                                <Typography>{a.subjects
                                  .map(s => s.name)
                                  .sort((a, b) => a - b)[0]}</Typography>
                                <Typography fontSize={14} color={theme.palette.background.dark}>{moment(a.subjects
                                  .map(s => new Date(s.exam_date))
                                  .sort((a, b) => a - b)[0])?.format('DD MMM, YYYY')}</Typography>
                              </Box>
                            ) : (
                              <Box>
                                <Typography>{a.test_type}</Typography>
                                <Typography fontSize={14} color={theme.palette.background.dark}>{a.exam_date ? moment(a.exam_date).format('DD MMM, YYYY') : ''}</Typography>
                              </Box>
                            )
                          }
                        />
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Typography color={theme.palette.background.dark}>Exam Not Found</Typography>
                  </Box>
                )
              }
            />
          )}
          <ExamListing
            setAddOpen={setAddOpen}
            setEdit={setEdit}
            filters={filters}
            setFilters={setFilters}
            exams={exams}
            setExams={setExams}
            getExams={getExams}
            getUpComingExam={getUpComingExam}
            examType={examType}
            setExamType={setExamType}
          />
        </Grid>
        <Grid item md={3}>
          {ExamPlans.map((a, index) => (
            <CommonCard
              key={index}
              paddingBottom="0px"
              borderRadius={1}
              padding="10px"
              content={
                <Box
                  sx={{
                    background: '#E0E0E080',
                    borderRadius: 1,
                    padding: 2
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                  >
                    <img
                      src={`/Images/${a.name}.png`}
                      alt="subscription-logo"
                      height="60px"
                    />
                    <Box sx={{ width: '100%' }}>
                      <Box display="flex" gap={1} alignItems="center" justifyContent="space-between">
                        <Typography variant="h5">{a.name}</Typography>
                        {a.isActive && (
                          <Box
                            sx={{
                              background: theme.palette.background.main,
                              textAlign: 'center',
                              borderRadius: 0.8,
                              width: 60,
                              height: 25,
                              marginRight: 1
                            }}
                          >
                            <Typography sx={{ color: theme.palette.success.main }}>Active</Typography>
                          </Box>
                        )}
                      </Box>
                      <Typography sx={{ fontWeight: 600 }}>${a.price} <span style={{ color: theme.palette.icon.light, fontWeight: 'normal' }}>/ month</span></Typography>
                    </Box>
                  </Box>
                  <Typography mt={1} color={theme.palette.background.dark}>You're on a solid path with notable strengths in several areas. Your profile shows promise.</Typography>
                </Box>
              }
              footerContent={
                <CommonButton
                  label="Upgrade"
                  size="md"
                  marginBottom="0px"
                  height='35px'
                  marginTop="0px"
                />
              }
            />
          ))}
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Exams;